import Unit from './Unit'

export default interface DataSpec {
    dataType: DataType;
}

abstract class AbstractDataSpec implements DataSpec {
    dataType!: DataType
}

export enum DataType {
    STRUCT = "STRUCT",
    ARRAY = "ARRAY",
    TEXT = "TEXT",
    BOOL = "BOOL",
    ENUM = "ENUM",
    INT = "INT",
    FLOAT = "FLOAT",
    DOUBLE = "DOUBLE"
}

export const numberTypes: Array<DataType> =
    [
        DataType.INT,
        DataType.FLOAT,
        DataType.DOUBLE
    ]

export const nameValueTypes: Array<DataType> =
    [
        DataType.ENUM,
        DataType.BOOL
    ]

export function isNumberType(dataType: DataType): boolean {
    return numberTypes.includes(dataType)
}

export function isTextType(dataType: DataType): boolean {
    return dataType == DataType.TEXT
}

export function isBoolType(dataType: DataType): boolean {
    return dataType == DataType.BOOL
}

export function isEnumType(dataType: DataType): boolean {
    return dataType == DataType.ENUM
}

export function isNameValueType(dataType: DataType): boolean {
    return nameValueTypes.includes(dataType)
}

export class TextSpec extends AbstractDataSpec {
    readonly dataType = DataType.TEXT
    length!: string
}

export interface NameValueSpec {
    name: string;
    value: string;
}

export enum BoolValue {
    FALSE = '0',
    TRUE = '1'
}

export class BoolSpec extends AbstractDataSpec implements NameValueSpec {
    readonly dataType = DataType.BOOL
    name!: string
    readonly value!: BoolValue

}

export class TrueSpec extends BoolSpec {
    readonly value = BoolValue.TRUE
}

export class FalseSpec extends BoolSpec {
    readonly value = BoolValue.FALSE
}

export class BoolSpecPair extends Array<BoolSpec> {
    constructor() {
        super();
        this.push(new FalseSpec())
        this.push(new TrueSpec())
    }
}

export class EnumSpec extends AbstractDataSpec implements NameValueSpec {
    readonly dataType = DataType.ENUM
    name!: string
    value!: string
}

export interface NumberSpec extends DataSpec {
    min: string;
    max: string;
    step: string;
    unit?: Unit | undefined;
}

export abstract class AbstractNumberSpec implements NumberSpec {
    abstract dataType: DataType
    max!: string
    min!: string
    step!: string
    unit?: Unit
}

export class IntSpec extends AbstractNumberSpec {
    dataType: DataType = DataType.INT

    constructor(max = "100", min = "1", step = "1", unit: Unit | undefined = undefined) {
        super();
        super.max = max
        super.min = min
        super.step = step
        super.unit = unit
    }
}

export class FloatSpec extends AbstractNumberSpec {
    dataType: DataType = DataType.FLOAT

    constructor(max = "100", min = "1", step = "1", unit: Unit | undefined = undefined) {
        super();
        super.max = max
        super.min = min
        super.step = step
        super.unit = unit
    }
}

export class DoubleSpec extends AbstractNumberSpec {
    dataType: DataType = DataType.DOUBLE

    constructor(max = "100", min = "1", step = "1", unit: Unit | undefined = undefined) {
        super();
        super.max = max
        super.min = min
        super.step = step
        super.unit = unit
    }
}
